export default __webpack_public_path__ + "static/media/Logo.63a9c61a.png";